import axios from "axios";

const API = axios.create({
   baseURL: process.env.REACT_APP_API_URL
});

API.interceptors.request.use((config) => {
   const token = localStorage.getItem("token");
   if (token) {
      config.headers.Authorization = `Bearer ${token}`;
   }
   return config;
});

API.interceptors.response.use(
   (response) => response,
   (error) => {
      console.error("API Error:", error.response?.data || error.message);
      return Promise.reject(error);
   }
);

export default API;


